
import { Button } from '@/components/ui/button'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useEffect, useMemo, useState } from 'react'

export default function ModalChangePassword({ handleChangePassword, isOpen = false, onClose }: { isOpen: boolean, handleChangePassword: (password: string) => void, onClose: () => void }) {
  const [password, setPassword] = useState<string>('')
  const [confirmPassword, setConfirmPassword] = useState<string>('')

  useEffect(() => {
    setPassword('')
    setConfirmPassword('')
  }, [isOpen])

  const checkPassword = useMemo(() => {
    if (password.length < 8) {
      return 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร'
    }
    if (password !== confirmPassword) {
      return 'รหัสผ่านไม่ตรงกัน'
    }
    return null
  }, [password, confirmPassword])

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>เปลี่ยนรหัสผ่าน</AlertDialogTitle>
          <AlertDialogDescription>
            กรอกข้อมูลรหัสผ่านที่ต้องการเปลี่ยน
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="password">รหัสผ่านใหม่</Label>
            <Input
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="รหัสผ่านใหม่"
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="confirmPassword">ยืนยันรหัสผ่านใหม่</Label>
            <Input
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="ยืนยันรหัสผ่านใหม่"
            />
          </div>
          {checkPassword && <p className="text-red-500">{checkPassword}</p>}
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>ยกเลิก</AlertDialogCancel>
          <AlertDialogAction disabled={password.length === 0 || confirmPassword.length === 0 || checkPassword !== null} onClick={() => handleChangePassword(password)}>
            เปลี่ยนรหัสผ่าน
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
} 